import React from 'react';
import { pctTone } from '../hygiene/types';
import { FlowProjectRow } from './types';
import * as fmt from '../../lib/format';

interface Props {
  row: FlowProjectRow;
  selected: boolean;
  onSelect: (projectKey: string | null) => void;
}

// One project: the share of judged moves made by the usual owner. Pressing selects the project as
// the filter for everything below; pressing again clears it.
export default function FlowScoreCard({ row, selected, onSelect }: Props) {
  const pct = row.adherence_pct;
  return (
    <button
      type="button"
      onClick={() => onSelect(selected ? null : row.project_key)}
      aria-pressed={selected}
      className={`group w-full rounded-2xl bg-white p-4 text-left shadow-sm ring-1 transition-[transform,box-shadow,ring-color] duration-150 ease-out hover:shadow-md active:scale-[0.98] motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 contrast-more:ring-gray-400 ${
        selected ? 'ring-2 ring-blue-500' : 'ring-gray-200/70 hover:ring-gray-300'
      }`}
    >
      <div className="flex items-baseline justify-between gap-2">
        <div className="min-w-0">
          <div className="truncate text-xs font-semibold uppercase tracking-wider text-gray-500">{row.project_key}</div>
          <div className="truncate text-sm text-gray-600">{row.project_name ?? ''}</div>
        </div>
        <div className={`text-2xl font-bold tabular-nums tracking-tight ${pctTone(pct)}`}>{fmt.percent(pct)}</div>
      </div>
      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-gray-100" aria-hidden>
        <div className="h-full rounded-full bg-emerald-500" style={{ width: `${pct ?? 0}%` }} />
      </div>
      <div className="mt-2 text-xs text-gray-500">
        {row.checked === 0 ? 'No moves to judge' : `${row.outside} of ${row.checked} moves outside the usual owner`}
      </div>
      {row.rework > 0 && (
        <div className="mt-0.5 text-xs text-gray-500">
          {row.rework} went back{row.rework_rate_pct !== null ? ` · ${fmt.percent(row.rework_rate_pct)}` : ''}
        </div>
      )}
    </button>
  );
}
